/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "Accounting";

export function getAll(values) {
  return APIClient.post(`/Order${endpoint}/refunds`, values);
}
